module.exports = __webpack_public_path__ + "static/media/leftarrow.14b6dead.svg";